var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "refCustomTagsAndFieldsRichText" },
    [
      _c("SelectRichText", {
        ref: "refTriggerCustomTagsAndFieldsRichText",
        attrs: {
          label: _vm.$t.__(
            "richtext.CustomTagsAndFieldsRichText.select_richtext_label"
          ),
          disabled: _vm.disabled || _vm.isLoadingCustomTagsAndFields,
          "data-bot": "custom-tags-and-fields-richtext__insert"
        },
        nativeOn: {
          click: function($event) {
            return _vm.handleSelectRichText($event)
          }
        }
      }),
      _vm._v(" "),
      !_vm.isLoadingCustomTagsAndFields
        ? _c(
            "CompassDropdown",
            {
              ref: "refCustomTagsAndFieldsDropdown",
              attrs: {
                parentRef: "refTriggerCustomTagsAndFieldsRichText",
                isVisible: _vm.displayDropdownCustomTagsAndFields,
                filterable: "",
                noResultsLabel: _vm.$t.__("common.labels.no_result"),
                dropdownClass: "custom-tags-and-fields-richtext__dropdown"
              }
            },
            [
              _vm.enableAI && _vm.isSellsyAIEnabled
                ? _c(
                    "CompassTooltip",
                    {
                      attrs: {
                        content: _vm.$t.__(
                          "richtext.CustomTagsAndFieldsRichText.tooltip"
                        ),
                        disabled: !_vm.templateUsedInAutomation,
                        contentClass:
                          "custom-tags-and-fields-richtext__ai-tooltip",
                        placement: "right"
                      }
                    },
                    [
                      _c(
                        "CompassDropdownOption",
                        {
                          staticClass: "custom-tags-and-fields-richtext__ai",
                          attrs: {
                            label: _vm.$t.__("common.labels.tags_ai"),
                            value: "ai",
                            disabled: _vm.templateUsedInAutomation
                          },
                          on: { click: _vm.openCustomTagsAIModal }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "custom-tags-and-fields-richtext__ai-label",
                              class: {
                                "typographies-paragraph-medium-bold": !_vm.templateUsedInAutomation
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t.__("common.labels.tags_ai")) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("CompassIcon", {
                            staticClass:
                              "custom-tags-and-fields-richtext__ai-icon",
                            attrs: { icon: "ai-sparkles-simple" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.formattedTags, function(group, index) {
                return _c(
                  "CompassOptionGroup",
                  { key: index, attrs: { label: group.label } },
                  _vm._l(group.options, function(option, indexoption) {
                    return _c("CompassDropdownOption", {
                      key: indexoption,
                      attrs: {
                        label: option.label,
                        value: option.value,
                        labelCaption: option.caption,
                        selected: false
                      },
                      on: {
                        click: function($event) {
                          return _vm.addTagOrField(option)
                        }
                      }
                    })
                  }),
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCustomTagsAIModal
        ? _c("CustomTagsAIModal", {
            attrs: { data: _vm.dataCustomTagsAIModal, editor: _vm.editor },
            on: { addTagAI: _vm.addTagAI }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }